var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"closing"},[_c('p',{staticClass:"closing__text"},_vm._l((_vm.texts),function(text){return _c('span',{key:text.content,staticClass:"closing__content",style:({
        left: ((text.left) + "px"),
        transform: ("translate3d(" + (-_vm.scrollValue) + "px, 0, 0)")
      })},[_vm._v("\n      "+_vm._s(text.content)+"\n    ")])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0bfb6e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoClosing.vue
// module id = 623
// module chunks = 3